import { render, staticRenderFns } from "./artificial-service-add.vue?vue&type=template&id=36506ecf&scoped=true&"
import script from "./artificial-service-add.vue?vue&type=script&lang=js&"
export * from "./artificial-service-add.vue?vue&type=script&lang=js&"
import style0 from "./artificial-service-add.vue?vue&type=style&index=0&id=36506ecf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36506ecf",
  null
  
)

export default component.exports